import * as React from 'react';
import { Box, Typography } from '@mui/material';

interface DashboardMetricCardTitleProps {
  title: string;
  subtitle: string;
}

export const DashboardMetricCardTitle = ({ title, subtitle }: DashboardMetricCardTitleProps) => {
  return (
    <Box sx={{ minHeight: 48 }}>
      <Typography sx={{ fontWeight: 500 }}>{title}</Typography>

      <Typography variant="caption" color="textSecondary">
        {subtitle}
      </Typography>
    </Box>
  );
};
